import { gql } from "apollo-boost"

export const getCommentsFieldsVisitAndDeliverables= gql`
  query FieldsVisitAndDeliverablesComments($visitsAndDeliverablesComment: ID!) {
    FieldsVisitAndDeliverablesComments(visitsAndDeliverablesComment: $visitsAndDeliverablesComment) {
      id
      createdAt
      userType
      comment
      parentCommentId
    }
  }
`

export const getFieldsVisitAndDeliverablesCommentsCount = gql`
  query FieldsVisitAndDeliverablesCommentsCount($submission: ID!) {
    FieldsVisitAndDeliverablesCommentsCount(submission: $submission) {
      visitId
      count
    }
  }
`